
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wp4s_17c9j_9",
  "file-input": "awsui_file-input_1wp4s_17c9j_13",
  "file-input-button": "awsui_file-input-button_1wp4s_17c9j_28",
  "force-focus-outline-icon": "awsui_force-focus-outline-icon_1wp4s_17c9j_28",
  "force-focus-outline-button": "awsui_force-focus-outline-button_1wp4s_17c9j_49"
};
  